module.exports = __webpack_public_path__ + "img/chinesecompany196.f007fcef.png";